import { handleVersionMismatch } from 'actions/versionSync';
import * as UserActionTypes from 'actiontypes/user';
import { VersionMismatch } from 'services/BaseService';
import userService from 'services/UserService';
import { bootstrap } from 'actions/app';

import setJwt from './setJwt';

import handleAccessCodeResult from './handleAccessCodeResult';
import createBootstrapOptions from 'actions/user/createBootstrapOptions';

const UserService = new userService();

/** ----------------------------------------------------------------------------
 * FACEBOOK
 -----------------------------------------------------------------------------*/
export default facebookLogin(UserService);

export function facebookLogin(service) {
  return res => async (dispatch, getState) => {
    // We're logging in
    dispatch(facebookLoginRequested());

    // Get access code from state, if it's there
    const { accessCodes: { accessCode } } = getState();
    const accessCodeName = accessCode.name;

    try {
      // Make the call to /api/facebook/processsignedrequest
      const { data } = await service.facebookLogin({ ...res, accessCodeName });

      // If we didn't get the stuff we needed from the back-end (probably
      // because the user initiated a FB login and cancelled), then log errors
      // and return
      if (!data.isSuccess) {
        dispatch(facebookLoginFailure(data));
        return;
      }

      // Add JWT to storage
      setJwt(window, data);

      // We've logged in successfully
      dispatch(facebookLoginSuccess(data));

      // If the user already has a character, then proceed
      if (data.hasCharacter) {
        // Run bootstrap actions
        dispatch(bootstrap(createBootstrapOptions(dispatch)));
        // Send us to the home page
        // history.push(location.state ? location.state.from : '/');
        // Handle access code result
        dispatch(handleAccessCodeResult(data));
      }
      return data;
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
        return;
      }
      // Dispatch an error action for our Airbrake listener
      dispatch(facebookLoginError(error));
    }
  };
}

const facebookLoginRequested = () => ({
  type: UserActionTypes.FACEBOOK_LOGIN_REQUESTED,
  isFetching: true,
});

const facebookLoginSuccess = data => ({
  hasCharacter: true,
  type: UserActionTypes.FACEBOOK_LOGIN_SUCCESS,
  payload: {
    loggedIn: true,
    accessCodeResult: data.accessCodeResult,
    user: data.user,
  },
});

const facebookLoginFailure = data => ({
  type: UserActionTypes.FACEBOOK_LOGIN_FAILURE,
  payload: data,
});

const facebookLoginError = error => ({
  type: UserActionTypes.FACEBOOK_LOGIN_ERROR,
  isFetching: false,
  error,
  status: error.response && error.response.status,
});